<template>
	<div class="union-of-aries_splash">

		<div class="splash_upcoming rsvp">
			<img src="./assets/images/bg-wingtip-appiarius.jpg"/>

			<div class="text-box">
				<router-link to="/" class="link-style">
                    &#8610; &nbsp;&nbsp;Main Page
                </router-link>
				<h6 class="margin-top-spacer">
					RSVP
				</h6>

				<div class="rsvp-card" v-if="activeRSVP">
					<h5><b>+.*｡</b>
						Thank you! 
					<b>*.+｡</b></h5>
					<hr />
					<span><i>The following reservation has been recorded:</i></span>	

					<ul>
						<li v-for="name in activeRSVP.name" :key="name.firstName">
							<span class="font-dark">
								{{name.firstName}} {{name.surName}} 
                                <template v-if="name.dinnerChoice != 'not-attending' && name.dinnerChoice">
                                    will be attending and has requested {{name.dinnerChoice.toUpperCase()}} dinner.
                                    <span v-if="name.dinnerNotes">
                                        <i>{{name.dinnerNotes}}</i>
                                    </span>
                                </template>
                                <template v-else>
                                    will <i>not</i> be attending.
                                </template>
                            </span>

                            <span class="font-dark" v-if="activeRSVP.hasRehearsal" style="margin-top: 0">
								{{name.firstName}} {{name.surName}} 
                                <template v-if="name.attendingRehearsal">
                                    will be 
                                </template>
                                <template v-else>
                                    will <i>not</i> be 
                                </template> attending the rehearsal dinner.
                            </span>
						</li>
					</ul>
					
					<br />

					<span><i>If you are in need of accommodations or details concerning the ceremony, visit the 
                        <router-link to="/">main page</router-link> for details.</i></span>

					<span><i>If your reservation is incorrect, you may start over and resubmit your information by 
                        <router-link :to="{ path: `/rsvp/${docId}` }">clicking here</router-link>.</i></span>

				</div>
                <div v-else class="loader">
                    <img src="./assets/images/loading.gif" />
                </div>
            </div>

            
		</div>

        <Accomodations hide-image="true"></Accomodations>
        <UnionOfAries></UnionOfAries>

	</div>
</template>

<script>
import UnionOfAries from './UnionOfAries.vue'
import Accomodations from './Accomodations.vue'

import { db, rsvpsRef } from './firebase';
var debounce = require('lodash.debounce');

export default {
    name: 'reserve',
    props: ['docId'],
    data () {
        return {
            activeRSVP: null,
            docUnsub: null,
        }
    },
    components: {
      UnionOfAries,
      Accomodations,
    },
    watch: {
        'docId': function(docId) {
            this.activeRSVP = null;
            this.loadDoc();
        },
    },
    methods: {
        loadDoc: function() {
            let datum = this;
            datum.docUnsub = rsvpsRef.doc(datum.docId).onSnapshot(function(doc) {
                if (doc.exists) {
                    datum.activeRSVP = doc.data();
                } else {
                    datum.$router.push({ path: `/rsvp` });
                }
            });
        },
    },
    created: function() {
        this.loadDoc();
    },
    destroyed: function() {
        if (this.docUnsub) {
            this.docUnsub();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/Confirmation.vue